module.exports = __webpack_public_path__ + "img/horizontal_7_2_pp2_6005.0c444219.png";